(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('AnalyticsController', ["$scope", "widgetPolling", "sizeClasses", "$routeParams", "path", "sideMenuManager", "feature", "modulesManager", "$route", function ($scope, widgetPolling, sizeClasses, $routeParams, path, sideMenuManager, feature, modulesManager, $route) {
        $scope.sideMenuManager = sideMenuManager;
        var page = $routeParams.page;
        var moduleApp = modulesManager.cloudApp(page);
        if (!moduleApp) {
            modulesManager.reloadModules().then(function (data) {
                moduleApp = modulesManager.cloudApp(page);
                init();
            });
        } else {
            init();
        }
        function init() {
            var title = 'Analytics';
            if (moduleApp) {
                title = (moduleApp.isSaas ? 'Analytics - ' : '') + moduleApp.title;
                modulesManager.currentModule(moduleApp.name);
            }
            $route.current.fullTitle = title;
            $route.current.isSaas = moduleApp.isSaas;
            $route.current.name = moduleApp.name;
            if (moduleApp.img)
                $route.current.img = moduleApp.img;
            path('dashboard').ctrl('dashboard').jsonRel(page + '.dashboard').retrieve().then(function (response) {
                if (response.data.showSecurityEvents)
                    $scope.showSecurityEvents = page;
            });
            widgetPolling.updateWidgets(path('dashboard').ctrl('dashboard').jsonRel(page + '.dashboard').path, path('dashboard').ctrl('dashboard').jsonRel('common-widgets').path, {
                hideV1Only: true,
                showV2Only: true,
                infoboxesNoColor: true,
                infoboxesFontColor: true
            });
            $scope.widgetPolling = widgetPolling;
            $scope.getSizeClasses = sizeClasses;
            $scope.wrapperClass = 'dashboard';
            $scope.refreshBtnOpt = {
                wrapClass: 'refresh-analytics-page',
                onClickedMsg: 'do-refresh-analytics-page',
                onFinishedMsg: 'done-refresh-analytics-page'
            };
        }
    }]);
}());